import Widget from "lib/ui/Widget";
import * as popper from "@popperjs/core";
import { ewent, observe } from "../../../lib/reactive";
import { util } from "../../../lib/util/util";
import { C } from "../../../lib/ui/constructors";
import jquery from "jquery";
var inlineimg = C.inlineimg;
export class AbstractDropdownSelection extends Widget {
    constructor(options, inital_item) {
        super(c("<div class='nisl-selectdropdown'>"));
        this.options = options;
        this.dropdown = null;
        this.selected = ewent();
        this.enabled = observe(true);
        this._list_constructor = async () => [];
        this.selection = observe(inital_item);
        this.input_container = c().appendTo(this);
        this.selection.subscribe(item => {
            this.renderInput();
        }, true);
        this.enabled.subscribe(enabled => {
            this.input?.toggleClass("disabled", !enabled);
        });
        this.setItems([inital_item]);
    }
    renderInput() {
        this.input = c("<div class='nisl-textinput nisl-selectdropdown-input' tabindex='-1'>")
            .css("padding-right", "13px")
            .on("click", (e) => {
            this.openDropdown();
        })
            .append(this.construct(this.selection.value()), inlineimg("/assets/nis/dropdown.png")
            .addClass("nisl-selectdropdown-arrow"))
            .appendTo(this.input_container.empty());
    }
    construct(v) {
        return this.options.type_class?.toHTML
            ? this.options.type_class.toHTML(v)
            : c(`<div>${v}</div>`);
    }
    setItems(items) {
        if (Array.isArray(items)) {
            this._list_constructor = () => Promise.resolve(items);
        }
        else {
            this._list_constructor = items;
        }
        if (this.dropdown) {
            (async () => {
                this.dropdown.setItems(await this._list_constructor());
            })();
        }
        return this;
    }
    async openDropdown() {
        if (!this.enabled.value())
            return;
        const focus_widget = this.onOpen();
        this.dropdown = new AbstractDropdownSelection.DropDown({
            dropdownClass: 'nisl-selectdropdown-options',
            renderItem: (i) => {
                return c().append(this.construct(i));
            }
        })
            .setItems(await this._list_constructor())
            .setHighlighted(this.selection.value())
            .onClosed(() => {
            this.dropdown = null;
            this.renderInput();
        })
            .onSelected(i => {
            this.selection.set(i);
            this.selected.trigger(i);
        })
            .open(this, focus_widget);
        if (this.dropdown)
            return;
    }
    /**
     * Is called whenever the dropdown is opened. Subclasses can use this to replace the original input by a text input for example.
     *
     * @return Must return the focus handler, i.e. the element that receives key events. The dropdown by default.
     */
    onOpen() {
        return this.input_container;
    }
    setValue(v) {
        this.selection.set(v);
        return this;
    }
    onSelection(f, trigger_now = false) {
        this.selected.on(f);
        if (trigger_now)
            f(this.selection.value());
        return this;
    }
    setEnabled(value) {
        this.enabled.set(value);
        return this;
    }
}
(function (AbstractDropdownSelection) {
    var positiveMod = util.positiveMod;
    class DropDown {
        constructor(options) {
            this.options = options;
            this.selectable_items = observe([]);
            this.highlight_index = observe(null);
            this.selected = ewent();
            this.closed = ewent();
            if (!options.renderItem)
                options.renderItem = (v) => c().text(JSON.stringify(v));
            this.selectable_items.subscribe((items, old_items) => {
                /*
                if (this.highlight_index.value() != null) {
                    let new_index = items.indexOf(old_items[this.highlight_index.value()])
        
                    this.highlight_index.set(new_index >= 0 ? new_index : 0)
                }*/
                this.highlight_index.set(0);
                this.renderItems();
            });
            this.highlight_index.subscribe((highlight, old_highlight) => {
                if (this.rows) {
                    if (old_highlight != null)
                        this.rows[old_highlight]?.toggleClass("selected", false);
                    if (highlight != null)
                        this.rows[highlight]?.toggleClass("selected", true)
                            ?.raw()?.scrollIntoView({ block: "nearest", inline: "nearest" });
                }
            });
        }
        select(item) {
            this.selected.trigger(item);
            this.close();
        }
        setItems(items) {
            this.selectable_items.set(items);
            return this;
        }
        renderItems() {
            if (this.container) {
                this.container.empty();
                this.rows = this.selectable_items.value().map((item, index) => {
                    return this.options.renderItem(item)
                        .toggleClass("selected", this.highlight_index.value() == index)
                        .on("click", (e) => {
                        e.stopPropagation();
                        this.select(item);
                    })
                        .on("mousemove", () => {
                        this.highlight_index.set(index);
                    })
                        .appendTo(this.container);
                });
                if (this.selectable_items.value().length == 0) {
                    this.container.append(c().text("No matches").css("font-style", "italic"));
                }
            }
        }
        open(reference, focus_widget) {
            this.container = c("<div style='z-index: 1000000' tabindex='0'></div>")
                .addClass("nisl-abstract-dropdown");
            if (focus_widget) {
                if (focus_widget.raw().getAttribute("tabindex") == null)
                    focus_widget.setAttribute("tabindex", "-1");
                this.focus_widget = focus_widget;
                focus_widget
                    .on("keydown", this.input_handler = (e) => {
                    if (e.key == "Escape") {
                        e.stopPropagation();
                        this.focus_widget.raw().blur();
                    }
                    if (e.key == "ArrowUp") {
                        this.highlight_index.set(positiveMod((this.highlight_index.value() ?? this.selectable_items.value().length) - 1, this.selectable_items.value().length));
                    }
                    if (e.key == "ArrowDown") {
                        this.highlight_index.set(positiveMod((this.highlight_index.value() ?? (this.selectable_items.value().length - 1)) + 1, this.selectable_items.value().length));
                    }
                    if (e.key == "Enter") {
                        let i = this.highlight_index.value();
                        if (i != null && i >= 0 && i < this.selectable_items.value().length)
                            this.select(this.selectable_items.value()[i]);
                    }
                })
                    .on("focusout", (e) => {
                    if (!(e.originalEvent.relatedTarget instanceof HTMLElement)
                        || (!this.container.container.is(e.originalEvent.relatedTarget)
                            && this.container.container.has(e.originalEvent.relatedTarget).length == 0)) {
                        this.close();
                    }
                })
                    .raw().focus();
            }
            this.container.addClass(this.options.dropdownClass || "nisl-abstract-dropdown-default-styling");
            this.renderItems();
            this.instance = popper.createPopper(reference.raw(), this.container.appendTo(getDropdownPane()).raw(), {
                placement: "bottom-start",
                modifiers: [
                    {
                        name: 'flip',
                        enabled: true,
                    },
                    {
                        name: "preventOverflow",
                        enabled: true,
                        options: {
                            boundary: "viewport",
                            rootBoundary: 'viewport',
                        }
                    },
                    {
                        name: 'widthSync', // Custom modifier name
                        enabled: true,
                        phase: 'beforeWrite',
                        fn: ({ state }) => {
                            state.styles.popper.width = `${state.rects.reference.width}px`; // Set tooltip width based on reference width
                            state.styles.popper.maxWidth = `${state.rects.reference.width}px`;
                        },
                    },
                ]
            });
            return this;
        }
        close() {
            if (this.instance) {
                this.instance.destroy();
                this.instance = null;
                this.container.remove();
                this.closed.trigger(undefined);
            }
            if (this.focus_widget) {
                this.focus_widget.container.off("keydown", this.input_handler);
                this.focus_widget = null;
                this.input_handler = null;
            }
        }
        onSelected(f) {
            this.selected.on(f);
            return this;
        }
        onClosed(f) {
            this.closed.on(f);
            return this;
        }
        setHighlighted(item) {
            let index = this.selectable_items.value().indexOf(item);
            if (index >= 0)
                this.highlight_index.set(index);
            return this;
        }
    }
    AbstractDropdownSelection.DropDown = DropDown;
    let _dropdownpane = null;
    function getDropdownPane() {
        if (!_dropdownpane)
            _dropdownpane = c("<div style='position: absolute; top: 0; left: 0; overflow: visible; max-width: 100%; max-height: 100%'>").appendTo(jquery("body"));
        return _dropdownpane;
    }
    AbstractDropdownSelection.getDropdownPane = getDropdownPane;
})(AbstractDropdownSelection || (AbstractDropdownSelection = {}));
